import React, { useEffect, useState } from "react";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import { useNavigate } from "react-router-dom";
import { roles } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import api from "../../services/api";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import NoDataFound from "../../shared/NoDataFound";
import { useForm } from "react-hook-form";
import { formatDate } from "../../utils/dateFormat";
import TableLoader from "../../shared/TableLoader";
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from "../../utils/Debounce";
import { SetCampCount, SetOpsSales,SetComponentId } from '../../redux/counterSlice'
import {
  SlButton,
  SlDrawer,
  SlCheckbox,
  SlTooltip,
  SlInput,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { CSVLink } from "react-csv";

function Invoice() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(5))
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [id, setId] = useState(-1);
  const [ro, setRo] = useState("");
  const [spent, setSpent] = useState(0);

  const [view, setView] = useState(false);
  const [viewPreview, setViewPreview] = useState(false);
  const [clicks, setClicks] = useState([]);
  const [impressions, setImpressions] = useState([]);
  const [campaigndata, setCampaignData] = useState([]);
  const [campaignids, setCampaignIds] = useState([]);
  const [total, setTotal] = useState('0');
  const SALES = useSelector(state => state.Head.opssales)
  const DATEFILTER = useSelector(state => state.Head.date)
  const HEADERSEARCH = useSelector(state => state.Head.adssearch)
  const [initialRender, setInitialRender] = useState(false)
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }

  let fullWatch = watch("full", false);
  let partialWatch = watch("partial", false);
  let watchAmount = watch("amount", 0);
  let watchCheque = watch("cheque", "");
  let watchUpi = watch("upi", "");
  let watchBank = watch("bank", "");

  const handleShow = () => {
    setView(!view);
  };

  const handlePreview = () => {
    setViewPreview(!viewPreview);
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    loadData(search, event.selected);
  };
  const csvHeaders = [
    { label: "Campaign Name", key: "campaign_name" },
    { label: " Campaign Type", key: "campaign_type" },
    { label: "Start Date", key: "start_date" },
    { label: "End Date", key: "end_date" },
    { label: "CPM", key: "cpm" },
    { label: "CPC", key: "cpc_price" },
    { label: "CPD", key: "cpd" },
    { label: "Clicks", key: "clicks" },
    { label: "Impressions", key: "impressions" },
    { label: "Spent", key: "spent" },
  ];
  const filteredData = campaigndata.length ?  campaigndata?.map(
    ({
      campaign_id,
      campaign_name,
      campaign_type,
      start_date,
      end_date,
      cpd,
      cpc_price,
      cpm,
    }) => {
      const startDate = formatDate(start_date);
      const endDate = formatDate(end_date);
      const total_click = clicks[campaignids.indexOf(campaign_id)];
      const total_imps = impressions[campaignids.indexOf(campaign_id)];
      const spent =
        campaign_type === "CPD"
          ? cpd
          : campaign_type === "CPC"
            ? (parseFloat(cpc_price) * parseFloat(total_click)).toFixed(2)
            : ((parseFloat(cpm) * parseFloat(total_imps)) / 1000).toFixed(2);
      return {
        campaign_name,
        campaign_type,
        start_date: startDate,
        end_date: endDate,
        impressions: total_imps,
        cpd,
        cpc_price,
        cpm,
        clicks: total_click,
        spent: spent,
      };
    }
  ) : [];

  const searchData = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0);
  };

  const loadData = async (search = "", page = 0) => {
    try {
      setInitialRender(true)
      setLoader(true);
      let res = await api({
        url: `/invoice`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: HEADERSEARCH,
          sales_ops: SALES,
          datefilter: DATEFILTER
        },
      });
      setData(res.data.data.length ? res.data.data : []);
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      setLoader(false);
      if (error?.response?.status === 401) navigate("/");
    }
  };

  useEffect(()=>{
    if(initialRender){
      loadData(HEADERSEARCH,0)
    }
  },[SALES, DATEFILTER, HEADERSEARCH])


  const loadCampaigns = async () => {
    if (campaignids.length) {
      try {
        let res = await api({
          url: "/invoice/getCampaign",
          method: "POST",
          responseType: "json",
          data: {
            campaignids,
          },
        });
        setCampaignData(res.data.length ? res.data : []);
        let total = 0;
        res.data.map((item) => {
          total = (Number(total) + Number(
            item.campaign_type === "CPD"
              ? item.cpd
              : item.campaign_type === "CPC"
                ? (
                  (item.cpc_price) *
                  (clicks[campaignids.indexOf(item.campaign_id)])
                ).toFixed(2)
                : (
                  ((item.cpm) *
                    (impressions[campaignids.indexOf(item.campaign_id)])) /
                  1000
                ).toFixed(2)
          )).toFixed(2)
        });
        setTotal(total);
        if (campaignids.length) {
          handlePreview(true);
        }
      } catch (error) {
        if (error?.response?.status === 401) navigate("/");
      }
    }
  };

  const onSubmit = async () => {
    if (fullWatch) {
      if (watchAmount === String(spent)) {
        try {
          setLoader(true);
          await api({
            url: `/invoice/update`,
            method: "POST",
            responseType: "json",
            data: {
              amount: watchAmount,
              payment_method:
                watchBank !== "" ? "Bank" : watchCheque !== "" ? "Cheque" : "UPI",
              payment_id:
                watchBank !== ""
                  ? watchBank
                  : watchCheque !== ""
                    ? watchCheque
                    : watchUpi,
              id: id,
            },
          });
          loadData(0);
          Toast("SUCCESS", "Amount Updated Successfully");

        } catch (error) {
          setLoader(false);
          if (error?.response?.status === 401) navigate("/");
        }
        setView(false);
      } else {
        Toast("error", "Amount is less than spent");
      }
    } else {
      try {
        setLoader(true);
        await api({
          url: `/invoice/update`,
          method: "POST",
          responseType: "json",
          data: {
            amount: watchAmount,
            payment_method:
              watchBank !== "" ? "Bank" : watchCheque !== "" ? "Cheque" : "UPI",
            payment_id:
              watchBank !== ""
                ? watchBank
                : watchCheque !== ""
                  ? watchCheque
                  : watchUpi,
            id: id,
          },
        });
        loadData(0);
        Toast("SUCCESS", "Amount Updated Successfully");
      } catch (error) {
        setLoader(false);
        if (error?.response?.status === 401) navigate("/");
      }
      setView(false);
    }
    reset()
  };

  useEffect(() => {
    loadCampaigns();
  }, [campaignids]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== roles.ops && role !== roles.financer && role !== roles.advertiser)
      navigate("/pagenotfound");
    loadData(search, 0);
  }, []);
  return (
    <>
      <div className="flex items-center mb-3">
        <h5 className="">Invoice</h5>
        {/* <aside className="flex gap-3 ml-auto">
          <SlInput className="w-72" size="small" placeholder="Way2News / D6/23-24/W2N/0001" onSlInput={debounce(searchData, 500)}>
            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
          </SlInput>
        </aside> */}
      </div>

      <div className="overflow-x-auto">
        <ScrollContainer>
          <table className="table table-bordered">
            <thead className="sticky top-0">
              <tr>
                <th>Invoice No</th>
                {localStorage.getItem("role") !== roles.advertiser && <th>Type</th>}
                <th>Ro Number</th>
                {localStorage.getItem('role') === roles.advertiser ? <th>Budget</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Spent</th> : <th>Spent</th>}
                <th>Company Name</th>
                {localStorage.getItem("role") === roles.ops && <th>Advertiser Name</th>}
                <th>Invoice Date</th>
                <th>Campaign Count</th>
                <th>Paid Date</th>
                <th>Paid Amount</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td>{item.invoice_id || "-"}</td>
                      {localStorage.getItem("role") !== roles.advertiser && <td><div className="flex gap-2">
                        <sl-badge variant={item.type === "Editorial" ? "primary" : item.type === "Local" ? "success" : "warning"}>{item.type}</sl-badge>
                      </div></td>}
                      <td>{item.ro_no || "-"}</td>
                      <td>{item.spent >= 0 ? `₹${(parseFloat(item.spent)).toFixed(2)}` : "-"}</td>
                      <td>{item.company_name || "-"}</td>
                      {localStorage.getItem("role") === roles.ops && <td>{item.advertiser_name || "-"}</td>}
                      <td>{formatDate(item.invoice_date) || "-"}</td>
                      <td>{item.campaign_count || "-"}</td>
                      <td>{item.paid_date ? formatDate(item.paid_date) : "-"}</td>
                      <td>{`₹${item.amount}`}</td>
                      <td>
                        {item.status === 0
                          ? <span className="unpaid-badge">Unpaid</span>
                          : item.status === 1
                            ? <span className="partial-badge">Partial</span>
                            : <span className="full-badge">Full</span>}
                      </td>
                      <td>
                        {
                          <>
                           {localStorage.getItem("role") === roles.ops &&  <sl-tooltip content="Update payment">
                              <sl-icon-button
                                library="lucide"
                                name="edit"
                                onClick={() => {
                                  handleShow();
                                  setId(item.id);
                                  setRo(item.invoice_id);
                                  setSpent(item.spent);
                                }}
                              ></sl-icon-button>
                            </sl-tooltip>}
                            <sl-tooltip content="Preview Campaigns">
                              <sl-icon-button
                                library="lucide"
                                name="view"
                                onClick={() => {
                                  setCampaignIds(item.campaign_id);
                                  setClicks(item.clicks);
                                  setImpressions(item.impressions);
                                  setRo(item.invoice_id);
                                }}
                              ></sl-icon-button>
                            </sl-tooltip>{" "}
                          </>
                        }
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </ScrollContainer>
      </div>
      <SlDrawer label="Update Payment" open={view} onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => setView(false)} style={{ '--size': '480px' }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <p className="mb-5 flex gap-3 items-center">
              <span>Updating Invoice with Invoice Number</span>
              <h6 className='font-semibold'>{ro}</h6></p>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="checkbox" disabled={partialWatch}  {...register("full", {
              required: !(fullWatch || partialWatch)
            })} />
            <label className="form-check-label" >Full Payment</label>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="checkbox" disabled={fullWatch}  {...register("partial", {
              required: !(fullWatch || partialWatch)
            })} />
            <label className="form-check-label" >Partial Payment</label>
          </div>
          {errors.partial && errors.full && (<p className="text-red-600">Please choose payment type</p>)}
          <div className="mb-3">
            <label className="mb-1">Amount</label>
            <div>
              <input type="number" className="form-control" {...register("amount", {
                required: true, validate: (value, formValues) => value >= '1'
              })} />
            </div>
            {errors.amount && (<p className="text-red-600">Enter Valid Amount</p>)}
          </div>
          <div className="mb-3">
            <label className='mb-1'>Cheque No</label>
            <div>
              <input type="text" className="form-control" {...register("cheque", {
                required: !(watchCheque || watchBank || watchUpi), minLength: 6, maxLength: 6, pattern: { value: /^[0-9]+$/, message: "Enter Valid Check Number" }
              })} />
            </div>
            {errors.cheque && <p className="text-red-600">{errors.cheque.message}</p>}
          </div>
          <div className="mb-3">
            <label className='mb-1'>UPI ID</label>
            <div>
              <input type="text" className="form-control" {...register("upi", {
                required: !(watchCheque || watchBank || watchUpi), pattern: { value: /^[\w.-]+@[\w.-]+$/, message: "Enter Valid UPI Id" }
              })} />
            </div>
            {errors.upi && <p className="text-red-600">{errors.upi.message}</p>}
          </div>
          <div className="mb-3">
            <label className='mb-1'>Transcation Id</label>
            <div>
              <input type="text" class="form-control" {...register("bank", {
                required: !(watchCheque || watchBank || watchUpi), minLength: 12, maxLength: 18
              })} />
            </div>
            {watchBank && errors.bank && <p className="text-red-600">Enter Valid Transcation Id</p>}
          </div>
          {
            errors.cheque && errors.upi && errors.bank && (
              <p className='text-red-600'>Enter Cheque Number or UPI ID or Bank Transcation Id</p>
            )
          }
          <SlButton variant='primary' type='submit'>Submit</SlButton>
        </form>


      </SlDrawer>

      <SlDrawer
        label={`Campaignwise detials of ${ro}`}
        open={viewPreview}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => { setViewPreview(false); setCampaignIds([]) }}
        style={{ "--size": "70vw" }}
      >
        <div className="flex justify-end mb-5">
          <CSVLink
            data={filteredData}
            headers={csvHeaders}
            filename={`invoice_${ro}.csv`}
          >
            <sl-icon-button
              library="lucide"
              title="Download"
              name="download"
            ></sl-icon-button>
          </CSVLink>
        </div>
        <div className="overflow-x-auto">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Campaign Name</th>
                <th>Campaign Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>CPM</th>
                <th>CPC</th>
                <th>CPD</th>
                {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ?  <th scope="col">Clicks</th> : <th>Audience Engaged</th>}
                {(localStorage.getItem('role') !== roles.advertiser && localStorage.getItem('role') !== roles.salesperson ) ?  <th scope="col">Impressions</th> : <th>Audience Viewed</th>}
                {localStorage.getItem('role') === roles.advertiser ? <th>Budget</th> : localStorage.getItem('role' === roles.salesperson ) ?  <th scope="col">Spent</th> : <th>Spent</th>}
              </tr>
            </thead>
            {campaigndata?.length && !loader ? (
              <tbody>
                {campaigndata.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td >{item.campaign_name || "-"}</td>
                      <td>{item.campaign_type || "-"}</td>
                      <td>{formatDate(item.start_date)}</td>
                      <td>{formatDate(item.end_date)}</td>
                      <td >{item.cpm || "-"}</td>
                      <td>{item.cpc_price || "-"}</td>
                      <td>{item.cpd || "-"}</td>
                      <td>{clicks[campaignids.indexOf(item.campaign_id)]}</td>
                      <td>
                        {impressions[campaignids.indexOf(item.campaign_id)]}
                      </td>
                      <td>
                        ₹{item.campaign_type === "CPD"
                          ? item.cpd
                          : item.campaign_type === "CPC"
                            ? (
                              (item.cpc_price) *
                              (
                                clicks[campaignids.indexOf(item.campaign_id)]
                              )
                            ).toFixed(2)
                            : (
                              ((item.cpm) *
                                (
                                  impressions[campaignids.indexOf(item.campaign_id)]
                                )) /
                              1000
                            ).toFixed(2)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </div>
        <div className="flex justify-end">
          <h6>Total = {total}</h6>
        </div>
      </SlDrawer>
      <div className=" right-fixed mt-4">
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>
    </>
  );
}

export default Invoice;
